export const environment = {
  production: false,
  apiUrl: 'https://api.web.test.procesa.com.py/v1/',
  appId: 'py.com.procesa.test.sistema',
  firebase: {
    apiKey: "AIzaSyBuM5mxRdiW4N0RbIXXHJn2MMjoy0It7RU",
    authDomain: "negofin-167d3.firebaseapp.com",
    projectId: "negofin-167d3",
    storageBucket: "negofin-167d3.appspot.com",
    messagingSenderId: "1088907454626",
    appId: "1:1088907454626:web:5e0f213ffbb16c424c4ffb",
    measurementId: "G-ZG86QQ3L42"
  }
};

